export const TOOLS_TYPE = 'tools'
export const FEATURES_TYPE = 'features'

export const ALL_TOOLS_SECTION = '_all_libraries'
export const ALL_FEATURES_SECTION = '_all_features'

export const ITEMS_ID = '_items'
export const CARDINALITIES_ID = '_cardinalities'

export const TOOLS_OPTIONS = [
    'would_use',
    'would_not_use',
    'interested',
    'not_interested',
    'never_heard'
]

export const FEATURES_OPTIONS = ['never_heard', 'heard', 'used']

export const FEATURES_OPTIONS2 = [
    'never_heard',
    'interested',
    'not_interested',
    'used_positive',
    'used_negative'
]

export const OVERALL = 'overall'

export const NO_ANSWER = 'no_answer'

export const NO_MATCH = 'no_match'

export const OTHER_ANSWERS = 'other_answers'

export const CUTOFF_ANSWERS = 'cutoff_answers'

export const OVERLIMIT_ANSWERS = 'overlimit_answers'

export const NOT_APPLICABLE = 'na'

export const DEFAULT = 'default'

export const DISCARDED_ANSWER = 'discarded_answer'

export const UNSUPPORTED_LANGUAGE = 'unsupported_language' // e.g not english

export const CUSTOM_NORMALIZATION = 'custom_normalization'

export const AI_NORMALIZATION = 'ai_normalization'

export const IMPORTED_NORMALIZATION = 'imported_normalization'

export const INSUFFICIENT_DATA = 'insufficient_data'

export const PERCENTAGE_SURVEY = 'percentageSurvey'
export const PERCENTAGE_QUESTION = 'percentageQuestion'
export const PERCENTAGE_BUCKET = 'percentageBucket'
export const COUNT = 'count'

export const MAIN_UNITS = [PERCENTAGE_SURVEY, PERCENTAGE_QUESTION, COUNT]

export const PARTIAL_WORD_INDICATOR = '[p]'

export const ENTIRE_CONTENTS_INDICATOR = '[e]'

export const WHOLE_WORD_INDICATOR = '[w]'

export const LIST_INDICATOR = '[l]'

export const NEUTRAL_SENTIMENT = 'neutral'
export const POSITIVE_SENTIMENT = 'positive'
export const NEGATIVE_SENTIMENT = 'negative'

export const SENTIMENT_FACET = '_sentiment'

export const CATCHALL_PREFIX = 'catchall_'

export const PAST_PARTICIPATIONS = 'past_participations'
export const FUTURE_PARTICIPATIONS = 'future_participations'

export const USER_METADATA_SECTION = '_user_metadata'

export const DEFAULT_ASSETS_URL = 'https://assets.devographics.com'
export const DEFAULT_SURVEYFORM_URL = 'https://survey.devographics.com'
export const DEFAULT_API_URL = 'https://api.devographics.com'

export const INVALID = 'invalid'
export const NO_PAIN_POINT = 'no_pain_point'
export const INVALID_VALUES = [INVALID, NO_PAIN_POINT]

/*

Correlation strength bands: the lowest |correlation| that earns each label,
strongest first; anything below the last one is "weak". Shared so that the API
(which labels every correlation) and the results spectrum legend (which draws
the bands) can't drift apart.

Changing these changes computed results: bump CACHE_VERSION in
api/src/compute/correlations_constants.ts at the same time.

*/
export const CORRELATION_STRENGTH_BANDS = [
    ['very_strong', 0.4],
    ['strong', 0.25],
    ['moderate', 0.15]
] as const
